<template>
	<div class="wechat-video-channel">
		<config-item label="模块标题">
			<el-input v-model="cloneValue.title" autosize type="textarea" style="width: 100%" size="small"> </el-input>
		</config-item>
		<config-item label="视频号id">
			<el-input v-model="cloneValue.finder_user_name" autosize type="textarea" style="width: 100%" size="small"> </el-input>
		</config-item>
		<el-divider></el-divider>
		<config-item label="视频号主体" style="margin-top: -10px">
			<el-radio-group v-model="cloneValue.subject_type" size="mini" style="width: 150px; transform: translateY(9px); display: flex">
				<el-radio :label="1">与小程序同主体</el-radio>
				<el-radio :label="2" style="margin-left: -18px">与小程序非同主体</el-radio>
			</el-radio-group>
		</config-item>
	</div>
</template>

<script>
import schemaMixin from '@/mixin/schemaMixin';
export default {
	name: 'SchemaWeChatVideoChannel',
	mixins: [schemaMixin],
	data() {
		return {
			cloneValue: {},
		};
	},
	created() {
		if (this.mValue) {
			this.cloneValue = this.$cloneDeep(this.mValue);
		} else {
			this.cloneValue = {
				title: '视频号',
				finder_user_name: '',
				subject_type: 1,
			};
		}
		// console.log(666, this.cloneValue, this.mValue);
	},
	watch: {
		cloneValue: {
			handler(val) {
				this.mValue = val;
			},
			deep: true,
		},
	},
	methods: {},
};
</script>
<style lang="scss" scoped>
.wechat-video-channel {
	padding: 0 10px;
	margin-bottom: 20px;
}
</style>
